import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ModuleService } from '@services/settings/module/module.service';
import { Observable, map, catchError } from 'rxjs';
import { AlertService } from '@services/utils/alerts/alert.service';
import { Storage } from '@ionic/storage-angular';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModuleAvailabilityGuard implements CanActivate {
  private moduleRouteMapping = {
    'sample': 'sample',
    'new-gather': 'new-gather',
    'kit-request': 'kit-request',
    'request-history': 'request-history'
  };

  constructor(
    private moduleService: ModuleService,
    private router: Router,
    private alertService: AlertService,
    private storage: Storage
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const requestedPath = route.routeConfig?.path || '';
    const moduleRoute = this.moduleRouteMapping[requestedPath];

    if (!moduleRoute) {
      return new Observable(observer => observer.next(true));
    }

    return new Observable(observer => {
      this.storage.get(environment.localStorage).then(userData => {
        if (!userData?.rol_id) {
          this.router.navigate(['/login']);
          observer.next(false);
          return;
        }

        this.moduleService.getAll(userData.rol_id).subscribe({
          next: (modules: any[]) => {
            const moduleEnabled = modules.some(module => 
              module.route === moduleRoute && 
              module.active && 
              module.module_country_enabled
            );

            if (!moduleEnabled) {
              this.alertService.statusAlert(
                'Acceso no disponible',
                'Este servicio no está disponible temporalmente en su país.'
              );
              this.router.navigate(['/home']);
              observer.next(false);
            } else {
              observer.next(true);
            }
          },
          error: (error) => {
            console.error('Error checking module availability:', error);
            this.router.navigate(['/home']);
            observer.next(false);
          }
        });
      });
    });
  }
}